import { mergeAllUrls } from 'functions/mergeAllUrls'

export const skipEndPointIncognito = (
  baseHrefUrl: string,
  photoId: number,
  useAuthorizationUrl: boolean
): string => {
  if (useAuthorizationUrl) {
    return mergeAllUrls(baseHrefUrl)
  }

  return mergeAllUrls(baseHrefUrl, photoId)
}
